import BattleHeader from './BattleHeader';

export default BattleHeader;
